<div class="row event-header">
    <div class="text">
        <cmps-icon svgIcon="calendar-range"></cmps-icon>
        <span>{{ _i18n._9605_CREATE_EVENT | translate }}</span>
    </div>
    <button
        class="close"
        (click)="_onClose()"
    >
        <cmps-icon svgIcon="close"></cmps-icon>
    </button>
</div>

<cmps-wait-status *ngIf="state?.pending?.init"></cmps-wait-status>

<ng-container
    [formGroup]="_form.form"
    *ngIf="!state?.pending?.init"
>
    <div class="row">
        <div class="px-4 col-12">
            <div class="row">
                <div class="col-12">
                    <label
                        class="col-form-label"
                        id="eventtype-label"
                    >
                        {{ _i18n._9678_EVENT_TYPE | translate }}
                    </label>
                    <ng-select
                        class="ng-select--variant-4"
                        [options]="_eventTypes"
                        [noFilter]="999"
                        [placeholder]="
                            _i18n._9696_SELECT_EVENT_TYPE | translate
                        "
                        [ariaLabelledBy]="'eventtype-label'"
                        [formControlName]="_form.fields.EVENTTYPEID.name"
                    ></ng-select>
                    <div
                        class="text-danger"
                        *ngIf="
                            _submitted &&
                            _form.form.controls[_form.fields.EVENTTYPEID.name]
                                ?.errors?.required
                        "
                    >
                        {{ _form.fields.EVENTTYPEID.validationMsgs?.required }}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <label
                        class="col-form-label"
                        id="participants-label"
                    >
                        {{ _i18n._9681_PARTICIPANTS | translate }}
                    </label>
                    <div class="form-input">
                        <button
                            class="popup-trigger-button"
                            (click)="_onShowUserSearch($event)"
                        >
                            <div class="btn-text">
                                {{
                                    _getParticipantName(requiredParticipant) ||
                                        (_i18n._9691_INVITE_PEOPLE | translate)
                                }}
                            </div>
                            <cmps-icon svgIcon="chevron-down"></cmps-icon>
                        </button>
                    </div>
                    <div
                        class="text-danger"
                        *ngIf="
                            _submitted &&
                            _form.form.controls[_form.fields.PARTICIPANTS.name]
                                ?.errors?.reqParticipantsValidator
                        "
                    >
                        {{
                            _form.fields.PARTICIPANTS.validationMsgs
                                ?.reqParticipantsValidator
                        }}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <label
                        class="col-form-label"
                        id="commitments-label"
                    >
                        {{ _i18n._7389_CURRENT_COMMITMENTS | translate }}
                    </label>
                    <div class="form-input">
                        <div class="assoc-commitments">
                            <div
                                class="comm-item"
                                *ngFor="let comm of _selectedToAssociate"
                            >
                                <span
                                    >{{ _i18n._9422_BEHAVIOUR_ | translate }}
                                    {{ comm.behaviourName }}</span
                                >
                                <button class="close">
                                    <cmps-icon svgIcon="close"></cmps-icon>
                                </button>
                            </div>
                        </div>
                        <button
                            class="popup-trigger-button"
                            (click)="_onSelectEventsClick()"
                        >
                            <div class="btn-text">
                                {{
                                    (availableCommitmentsForUser?.length
                                        ? _i18n._9694_SELECT_COMMITMENTS
                                        : _i18n._9695_NO_COMMITMENTS
                                    ) | translate
                                }}
                            </div>
                            <cmps-icon svgIcon="chevron-down"></cmps-icon>
                        </button>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <label
                        class="col-form-label"
                        id="date-label"
                    >
                        {{ _i18n._9682_SELECT_A_DATE | translate }}
                    </label>
                    <div class="current-date">
                        {{ date | date: 'EEE, MMMM d, y' }}
                    </div>
                    <cmps-datetime-picker
                        [onlyDate]="true"
                        [fillWidth]="true"
                        [minDate]="_today"
                        [formControlName]="_form.fields.DATE.name"
                    ></cmps-datetime-picker>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-6 time-combo">
                    <label
                        class="col-form-label"
                        id="date-label"
                    >
                        {{ _i18n._9684_FROM | translate }}
                    </label>
                    <input
                        (focus)="stp.open()"
                        (click)="stp.open()"
                        cmpsDateTimePicker
                        [onlyTime]="true"
                        [minDate]="_today"
                        [autoFocus]="false"
                        #stp="cmpsDateTimePicker"
                        [formControlName]="_form.fields.STARTTIME.name"
                    />
                </div>
                <div class="col-6 time-combo">
                    <label
                        class="col-form-label"
                        id="date-label"
                    >
                        {{ _i18n._9685__TO | translate }}
                    </label>
                    <input
                        (focus)="etp.open()"
                        (click)="etp.open()"
                        cmpsDateTimePicker
                        [onlyTime]="true"
                        [autoFocus]="false"
                        [minDate]="startTimeValue"
                        #etp="cmpsDateTimePicker"
                        [formControlName]="_form.fields.ENDTIME.name"
                    />
                </div>
            </div>

            <div>
                <div
                    class="text-danger"
                    *ngIf="
                        _form.form.controls[_form.fields.ENDTIME.name]?.errors
                            ?.dateMin
                    "
                >
                    {{ _form.fields.ENDTIME.validationMsgs?.dateMin }}
                </div>
            </div>
        </div>
    </div>
    <div
        class="mt-4 row mb-1"
        *ngIf="overlapOtherEvent"
    >
        <div class="col-12 alert alert-warning">
            {{
                _i18n._9690_PLEASE_CHANGE_THE_EVENT_TIME__IT_OVERLAPS_WITH_OTHER_EVENT
                    | translate
            }}
        </div>
    </div>
    <div class="mt-4 row mb-1">
        <div class="col-12">
            <div class="bottom-buttons text-center">
                <!-- Create event -->
                <button
                    type="button"
                    class="btn btn-filled-blue mr-2 ml-2 create-event-btn"
                    (click)="_onSaveEvent()"
                    [disabled]="
                        !_form.form.dirty ||
                        overlapOtherEvent ||
                        !_form.form.valid
                    "
                    *ngIf="isActionNew"
                >
                    <span *ngIf="!state?.pending?.save; else saving">
                        {{ _i18n._9605_CREATE_EVENT | translate }}
                    </span>
                    <ng-template #saving>
                        <cmps-wait-status></cmps-wait-status>
                    </ng-template>
                </button>
                <!-- Create event from Calendar -->
                <button
                    type="button"
                    class="btn btn-filled-blue mr-2 ml-2 create-event-btn"
                    (click)="_onSaveEvent()"
                    [disabled]="
                        !_form.form.dirty ||
                        overlapOtherEvent ||
                        !_form.form.valid
                    "
                    *ngIf="isActionNewSlot"
                >
                    <span *ngIf="!state?.pending?.save; else saving">
                        {{ _i18n._9605_CREATE_EVENT | translate }}
                    </span>
                    <ng-template #saving>
                        <cmps-wait-status></cmps-wait-status>
                    </ng-template>
                </button>
                <button
                    type="button"
                    class="btn btn-filled-blue mr-2 ml-2 create-event-btn"
                    (click)="_onUpdateEvent()"
                    [disabled]="
                        !_form.form.dirty ||
                        overlapOtherEvent ||
                        !_form.form.valid
                    "
                    *ngIf="isActionUpdate"
                >
                    <span *ngIf="!state?.pending?.save; else saving">
                        {{ _i18n._9679_UPDATE_EVENT | translate }}
                    </span>
                    <ng-template #saving>
                        <cmps-wait-status></cmps-wait-status>
                    </ng-template>
                </button>
                <button
                    type="button"
                    class="btn btn-filled-blue mr-2 ml-2 create-event-btn"
                    (click)="_onCancelEvent()"
                    *ngIf="isActionCancel"
                >
                    <span *ngIf="!state?.pending?.save; else saving">
                        {{ _i18n._9680_CANCEL_EVENT | translate }}
                    </span>
                    <ng-template #saving>
                        <cmps-wait-status></cmps-wait-status>
                    </ng-template>
                </button>
            </div>
        </div>
    </div>
</ng-container>
